module.exports = __webpack_public_path__ + "img/eberdyshev.75c0a5bb.jpeg";